export default __webpack_public_path__ + "static/minimum-viable-product-come-puo-ridurre-rischi-azienda-astrorei-22cab04ac0de6e270e23fb47977c0b37.jpg";